// extracted by mini-css-extract-plugin
export default {"container":"FullScreen_container_s6YvF","title":"FullScreen_title_kalHO","subtitle":"FullScreen_subtitle_FGYAg","button":"FullScreen_button_F05I2"};